// extracted by mini-css-extract-plugin
export default {"bannerContainer":"Banner_bannerContainer__HKCwa"};